import React, { Fragment, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import "../Inventory.css";
import { getAdjustment } from "../../../Helpers/apiCalls/Inventory/AdjustmentApi";
import trash from "../../../Assets/Images/trash.png";
import Modal from "antd/es/modal/Modal";
import noDataImg from "../../../Assets/Images/no-data-img.png";
import Footer from "../../../Components/Footer/Footer";

/**
 *  COMPONENT: FORM TO ADD OR EDIT PAYMENT
 */
function ViewAdjustment() {
  const [inactive, setInactive] = useState(true);
  const { id, type } = useParams();
  let navigate = useNavigate();
  const [preview, setPreview] = useState(false);
  const [previewFile, setPreviewFile] = useState('');
  const [prevAttachments, setPrevAttachments] = useState([]);

  const [newItemAdjust, setNewItemAdjust] = useState({
    difference: "",
  });

  // DATA HANDLERS
  const [itemList, setItemList] = useState([]);
  const [adjustment, setAdjustment] = useState([]);

  async function fetchAdjustment() {
    const response = await getAdjustment(id);

    if (response.data.data) {
      var data = response.data.data[0];
      setAdjustment(data);
      setPrevAttachments(data.attachments)
    } else {
    }
  }

  function handleUserInput(e) {
    const { name, value } = e.target;
    const newList = newItemAdjust;
    newList[name] = value;
    setNewItemAdjust(newList);

    if (name === "physical_count") {
      newList["difference"] = parseInt(value) - parseInt(itemList.current_qty);
      setNewItemAdjust(newList);
      setNewItemAdjust({
        ...newItemAdjust,
        difference: parseInt(value) - parseInt(itemList.current_qty),
      });
    }
  }

  useEffect(() => {
    fetchAdjustment();
  }, []);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"INVENTORY"}
        />
      </div>
      <div
        className={`manager-container ${
          inactive ? "inactive" : "active"
        } review-container-main`}
      >
        <Row className="mb-4">
          <Col xs={12} lg={8}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> ADJUST INVENTORY</h1>
          </Col>
        </Row>

        {/* FORM */}

        <div className="edit-form ps-form">
          <Fragment>
            <Row className="review-container py-3">
              <Row>
                <Col xs={8} lg={3} >
                  <span className="review-label nc-modal-custom-row">
                    Item Description
                  </span>
                </Col>
                <Col xs={4} lg={3}>
                  <span className="review-data">{adjustment.item_name}</span>
                </Col>

                <Col xs={8} lg={3}>
                  <span className="review-label nc-modal-custom-row">
                    Inventory Unit
                  </span>
                </Col>
                <Col xs={4} lg={3}>
                  <span className="review-data">{adjustment.unit}</span>
                </Col>
              </Row>
              <Row>
                <Col xs={8} lg={3}>
                  <span className="review-label nc-modal-custom-row">
                    Branch
                  </span>
                </Col>
                <Col xs={4} lg={3}>
                  <span className="review-data">{adjustment.branch_name}</span>
                </Col>
                <Col xs={8} lg={3}>
                  <span className="review-label nc-modal-custom-row">
                    Current Level
                  </span>
                </Col>
                <Col xs={4} lg={3}>
                  <span className="review-data">
                    {adjustment.computer_count}
                  </span>
                </Col>
              </Row>
              <Row>
                <Col xs={7} lg={3}>
                  <span className="review-label nc-modal-custom-row">
                    Approved By
                  </span>
                </Col>
                <Col xs={5} lg={3}>
                  <span className="review-data">
                    {adjustment.approved_by_name}
                  </span>
                </Col>
              </Row>
            </Row>
            <Row className="pt-3">
              <Col xs={12} lg={6}>
                <span className="nc-modal-custom-row uppercase">
                  counted by
                  <label className="badge-required">{` *`}</label>
                </span>
                <input
                  type="text"
                  name="counted_by"
                  disabled
                  value={adjustment.counted_by_name}
                  className="nc-modal-custom-input form-control"
                />
              </Col>
              <Col xs={12} lg={6} className="mt-3 mt-lg-0">
                <span className="nc-modal-custom-row uppercase">
                  adjustment type
                  <label className="badge-required">{` *`}</label>
                </span>
                <input
                  type="text"
                  name="type_id"
                  disabled
                  value={adjustment.type_name}
                  className="nc-modal-custom-input form-control"
                />
              </Col>
            </Row>
            <Row className="pt-3">
              <Col xs={12} lg={6}>
                <span className="nc-modal-custom-row uppercase">
                  Physical count
                  <label className="badge-required">{` *`}</label>
                </span>
                <Form.Control
                  type="text"
                  disabled
                  name="physical_count"
                  className="ps-label-content"
                  value={adjustment.physical_count}
                  onChange={(e) => handleUserInput(e)}
                />
              </Col>
              <Col xs={12} lg={6} className="mt-3 mt-lg-0">
                <span className="nc-modal-custom-row uppercase">
                  difference
                  <label className="badge-required">{` *`}</label>
                </span>
                <input
                  type="number"
                  name="difference"
                  disabled
                  value={adjustment.difference}
                  className="nc-modal-custom-input form-control"
                />
              </Col>
            </Row>
            <Row className="pt-3">
              <Col xs={12} lg={4}>
                <span className="nc-modal-custom-row uppercase">
                   QTY on Receipt
                  {/* <label className="badge-required">{` *`}</label> */}
                </span>
                <Form.Control
                    type="number"
                    name="qty_on_receipt"
                    className="nc-modal-custom-text hide-spinner numeric-input"
                    value={adjustment.qty_on_receipt}
                    disabled
                />
              </Col>
              <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                <span className="nc-modal-custom-row uppercase">
                  Date Delivered
                </span>
                <Form.Control
                    type="date"
                    name="date_delivered"
                    className="nc-modal-custom-text hide-spinner numeric-input"
                    value={adjustment.date_delivered}
                    disabled
                />
              </Col>
              <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                <span className="nc-modal-custom-row uppercase">
                  Date Counted
                </span>
                <Form.Control
                    type="date"
                    name="date_counted"
                    className="nc-modal-custom-text hide-spinner numeric-input"
                    value={adjustment.date_counted}
                    disabled
                />
              </Col>
            </Row>
            <Row className="mt-4 mb-2">
              <Col>
                <span className="nc-modal-custom-row uppercase">
                  Admin remarks
                  <span className="edit-optional px-2">(Optional)</span>
                </span>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Control
                  as="textarea"
                  name="remarks"
                  disabled
                  defaultValue={adjustment.admin_remarks}
                  className="nc-modal-custom-input form-control"
                  onChange={(e) => handleUserInput(e)}
                />
              </Col>
            </Row>
            <Row className="mt-4 mb-2">
              <Col>
                <span className="nc-modal-custom-row uppercase">
                  Employee remarks
                  <span className="edit-optional px-2">(Optional)</span>
                </span>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Control
                  as="textarea"
                  name="remarks"
                  disabled
                  defaultValue={adjustment.remarks}
                  className="nc-modal-custom-input form-control"
                  onChange={(e) => handleUserInput(e)}
                />
              </Col>
            </Row>
            <div className="mt-4 noPrint mx-3">
                <Row className="review-data mb-2">
                    FILE ATTACHMENTS
                </Row>
                <Row className="">
                    {
                        prevAttachments && prevAttachments.map((attachment) => (
                            <Col xs={1} onClick={() => {setPreviewFile(attachment.file_url); setPreview(true)}} className="cursor-pointer preview-container">
                                <img src={attachment.file_url}  className="img-preview"/>
                            </Col>
                        ))
                    }
                    {
                        !prevAttachments || prevAttachments.length === 0 && 
                        <Col xs={1}>
                        <div className="no-data-cont d-flex justify-content-left preview-container">
                            <img src={noDataImg} alt="no data found" className="img-preview"/>
                        </div>
                        </Col>
                    }
                </Row>
            </div>
          </Fragment>

          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-secondary"
              onClick={() => navigate("/adjustments")}
            >
              Close
            </button>
          </div>
        </div>
      </div>
      <Modal open={preview} title={""} footer={null} onCancel={()=>setPreview(false)}>
          <Row className="justify-content-center">
              <img
                  alt="example"
                  style={{
                  width: '100%',
                  }}
                  src={previewFile}
              />
          </Row>
      </Modal>
      <Footer/>
    </div>
  );
}

export default ViewAdjustment;
